import { token } from '@atlaskit/tokens';

import {
  HAS_ACTIVE_HIGHLIGHT_CLASS,
  HIGHLIGHT_DELETE_INTENT_CLASS,
  SELECTION_HIGHLIGHT_CLASS,
  SELECTIONS_CONTAINER_ELEMENT_ID,
  SELECTIONS_FOCUS_BOX_ELEMENT_ID,
} from '../constants';

const STYLES_ID = 'selections-highlight-styles';

const CELL_HIGHLIGHT_Z_INDEX = 10;
const FOCUS_BOX_Z_INDEX = 20;

const borderColor = token('color.border.selected', '#0C66E4');
const backgroundColor = token('color.background.accent.blue.subtlest', '#E9F2FF');
const borderRadius = token('radius.small', '3px');
const dangerBorder = token('color.border.danger', '#E34935');
const dangerBackground = token('color.background.danger.hovered', '#FFD5D2');

const STYLES_CSS = `
  /* UI Cleanup: Hide insert dots when selection is active */
  .${HAS_ACTIVE_HIGHLIGHT_CLASS} [data-testid="insert-field-dot"],
  .${HAS_ACTIVE_HIGHLIGHT_CLASS} [data-testid^="add-entry-dot"] {
    opacity: 0 !important;
    pointer-events: none !important;
  }

  /* Core Selection Highlight Styles */
  .${SELECTION_HIGHLIGHT_CLASS} {
    position: absolute;
    display: none;
    box-sizing: border-box;

    border: 2px solid ${borderColor};
    background: color-mix(in srgb, ${backgroundColor} 25%, transparent);
    border-radius: ${borderRadius};

    pointer-events: none;
    z-index: ${CELL_HIGHLIGHT_Z_INDEX};

    will-change: transform, width, height;
    transform-origin: 0 0;
  }

  /* Focus Box Styles */
  #${SELECTIONS_FOCUS_BOX_ELEMENT_ID} {
    position: absolute;
    display: none;
    box-sizing: border-box;

    border: 2px solid ${borderColor};
    border-radius: ${borderRadius};

    pointer-events: none;
    z-index: ${FOCUS_BOX_Z_INDEX};

    will-change: transform, width, height;
    transform-origin: 0 0;
  }

  /* Delete Intent - Red Highlights */
  #${SELECTIONS_CONTAINER_ELEMENT_ID}.${HIGHLIGHT_DELETE_INTENT_CLASS} .${SELECTION_HIGHLIGHT_CLASS} {
    border-color: ${dangerBorder} !important;
    background: color-mix(in srgb, ${dangerBackground} 25%, transparent) !important;
    transition: border-color 0.2s, background 0.2s;
  }
`;

export class HighlightStyleManager {
  #styleElement: HTMLStyleElement | null = null;

  add(): void {
    if (document.getElementById(STYLES_ID)) {
      return;
    }

    this.#styleElement = document.createElement('style');
    this.#styleElement.id = STYLES_ID;
    this.#styleElement.textContent = STYLES_CSS;
    document.head.appendChild(this.#styleElement);
  }

  remove(): void {
    if (this.#styleElement) {
      this.#styleElement.remove();
      this.#styleElement = null;
    }

    const existing = document.getElementById(STYLES_ID);

    if (existing) {
      existing.remove();
    }
  }
}
